const messages: Record<string, string> = {
	'approval.discount': 'Rabat',
	'callback.description':
		'Niestety nie można było wygenerować kalkulacji dla tej polisa. Skontaktujemy się z Państwem w ciągu 24h w dni robocze w celu omówienia dalszych kroków.',
	'callback.headline': 'Państwa polisa została przetworzona.',
	'completeVehicleImagesModal.hasVehicleImageFront': 'Zdjęcie pojazdu z przodu',
	'completeVehicleImagesModal.hasVehicleImageLeft': 'Zdjęcie pojazdu z lewej strony',
	'completeVehicleImagesModal.hasVehicleImageRear': 'Zdjęcie pojazdu z tyłu',
	'completeVehicleImagesModal.hasVehicleImageRight': 'Zdjęcie pojazdu z prawej strony',
	'dashboardMileage.dashboard.paragraph': 'Zrób zdjęcie z widocznym przebiegiem pojazdu.',
	'feedback.headline': 'Dziękujemy za wykorzystanie PolicyCheck!',
	'feedback.headline.policyCheck': 'Dziękujemy za wykorzystanie PolicyCheck!',
	'feedback.rating': 'Jak ocenią Państwo usługę przetwarzania szkód PolicyCheck?',
	'feedback.rating.policyCheck': 'Jak ocenią Państwo usługę przetwarzania szkód PolicyCheck?',
	'imageRecognitionFeedback.isFrontPerspectiveVisible.infoText':
		'Upewnij się, że <b>przód</b> pojazdu jest w pełni widoczny.',
	'imageRecognitionFeedback.isFrontPerspectiveVisible.title': 'Przód pojazdu',
	'imageRecognitionFeedback.isFrontPerspectiveVisible.titleWarning': 'Przód pojazdu niewidoczny',
	'imageRecognitionFeedback.isLeftPerspectiveVisible.infoText':
		'Upewnij się, że <b>lewa</b> strona pojazdu jest w pełni widoczna i kontynuuj.',
	'imageRecognitionFeedback.isLeftPerspectiveVisible.title': 'Lewa strona pojazdu',
	'imageRecognitionFeedback.isLeftPerspectiveVisible.titleWarning':
		'Lewa strona pojazdu niewidoczna',
	'imageRecognitionFeedback.isRearPerspectiveVisible.infoText':
		'Upewnij się, że <b>tył</b> pojazdu jest w pełni widoczny i kontynuuj.',
	'imageRecognitionFeedback.isRearPerspectiveVisible.title': 'Tył pojazdu',
	'imageRecognitionFeedback.isRearPerspectiveVisible.titleWarning': 'Tył pojazdu niewidoczny',
	'imageRecognitionFeedback.isRightPerspectiveVisible.infoText':
		'Upewnij się, że <b>prawa</b> strona pojazdu jest w pełni widoczna i kontynuuj.',
	'imageRecognitionFeedback.isRightPerspectiveVisible.title': 'Prawa strona pojazdu',
	'imageRecognitionFeedback.isRightPerspectiveVisible.titleWarning':
		'Prawa strona pojazdu niewidoczna',
	'insuranceExpert.description':
		'Dziękujemy bardzo. Państwa polisa została przetworzona. Wkrótce skontaktujemy się z Państwem w celu określenia dalszych kroków.',
	'landing.aboutEasyclaim': 'Czym jest PolicyCheck?',
	'landing.aboutPolicyCheck': 'Czym jest PolicyCheck?',
	'landing.headline': 'SZYBKA INSPEKCJA POJAZDU',
	'landing.headline.policyCheck': 'SZYBKA INSPEKCJA POJAZDU',
	'landing.paragraph':
		'Prosimy o wykonanie 6 zdjęć pojazdu i zdjęcia dowodu rejestracyjnego.<br> Pamiętaj, aby zdjęcia były ostre i wykonane w świetle dziennym.',
	'landing.stepDescription.vinPicture':
		'Zrób zdjęcie numeru VIN znajdującą się na przedniej szybie lub tabliczce znamionowej, tak aby cały numer VIN był czytelny',
	'landing.termsAndConditionsLinkDescription':
		'W celu rozpoczęcia prosimy zaakceptować regulamin i kliknąc dalej.',
	'loader.error': 'Polisa nie może zostać załadowana. Proszę spróbować później...',
	'necessaryDocuments.paragraph.first':
		'A wykorzystać aplikację PolicyCheck będziesz musiał przygotować następujące zdjęcia: ',
	'thanksForFeedback.paragraph.first':
		'Twoja opinia o naszym serwisie jest dla nas bardzo ważna.Stale pracujemy nad ulepszeniem PolicyCheck, a Twoja opinia jest ważna dla naszego sukcesu.',
	'tutorialModal.headline.first.policyCheck': 'Czym jest PolicyCheck?',
	'tutorialModal.paragraph.first.policyCheck':
		'PolicyCheck jest to szybka inspekcja pojazdu. Proces oględzin składa się z 8 prostych kroków.',
	'tutorialModal.paragraph.second':
		'Pamiętaj, aby zdjecia były ostre i wykonane w świetle dziennym.',
	'vehicleInformation.headline.fourth': 'Zdjęcie dowodu rejestracyjnego',
	'vehicleInformation.headline.second': 'Zdjęcie dowodu rejestracyjnego',
	'vehicleInformation.paragraph.first': 'Przód',
	'vehicleInformation.paragraph.fourth': 'Tył',
	'waitForAudit.description.damageFound':
		'Następny krok należy do nas. O wyniku inspekcji poinformujemy Cię telefonicznie lub mailowo.',
	'waitForAudit.description.damageNotFound':
		'Następny krok należy do nas. O wyniku inspekcji poinformujemy Cię telefonicznie lub mailowo.',
	'waitForAudit.thankYou': 'Dziękujemy za przesłanie dokumentacji!',

	'invalidFile.size.title': 'Nieprawidłowy rozmiar zdjęcia',
	'invalidFile.size.description': 'Zdjęcie jest większe niż maksymalny dozwolony rozmiar.',
	'invalidFile.extension.title': 'Nieobsługiwany typ pliku',
	'invalidFile.extension.description':
		'Podany typ pliku nie jest obsługiwany. Obsługiwane typy plików: .jpg, .jpeg, .jfif, .heic, .heif, .png oraz .bmp',
};

export default messages;
